import {
  CopyButton,
  CopiedLabel,
  StyledInvitePopup,
  StyledInvitePopupContent,
  StyledInviteInputControls,
  StyledInviteButtonWrapper
} from './InvitePopup.styled';
import {
  PopupHeaderStart,
  PopupHeaderEnd,
  PopupHeaderTitle,
  PopupHeader
} from '../PopupHeader/PopupHeader.styled';
import { TextInput, AppModal, IconButton } from '../';
import { useContext, useState } from 'react';
import { AppContext } from '../../providers/AppContext';

const InvitePopup = () => {
  const { setShowInvitePopup } = useContext(AppContext);
  const [copied, setCopied] = useState(false);
  const [inviteUrl, setInviteUrl] = useState('https://basejump.xyz?code=123456');

  const onClickCopy = async () => {
    await navigator.clipboard.writeText(inviteUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <AppModal>
      <StyledInvitePopup>
        <PopupHeader>
          <PopupHeaderStart/>
            <PopupHeaderTitle>
              Invite your friends
            </PopupHeaderTitle>
          <PopupHeaderEnd />
        </PopupHeader>
        <StyledInvitePopupContent>
          <StyledInviteInputControls>
            <TextInput disabled={true} initText={inviteUrl} />
            <CopyButton onClick={onClickCopy} src='/assets/copy.svg'/>
          </StyledInviteInputControls>
	  <CopiedLabel>{copied ? 'Copied to Clipboard!' : ''}</CopiedLabel>
          <StyledInviteButtonWrapper>
            <IconButton onClick={() => setShowInvitePopup(false)}>OK</IconButton>
          </StyledInviteButtonWrapper>
        </StyledInvitePopupContent>
      </StyledInvitePopup>
    </AppModal>
  );
};

export default InvitePopup;
